import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useContext } from "react";
import GlobalContext from "../../context/Global";
import { StoryStyled } from "./Story.style";
var Story = function(props) {
    var getVideoDuration = props.getVideoDuration, story = props.story, action = props.action, playState = props.playState;
    var globalContext = useContext(GlobalContext);
    var width = globalContext.width, height = globalContext.height, loader = globalContext.loader, header = globalContext.header, storyStyles = globalContext.storyStyles, _storyInnerContainerStyles = globalContext.storyInnerContainerStyles, storyInnerContainerStyles = _storyInnerContainerStyles === void 0 ? {} : _storyInnerContainerStyles;
    var rendererMessageHandler = function(type, data) {
        switch(type){
            case "UPDATE_VIDEO_DURATION":
                getVideoDuration === null || getVideoDuration === void 0 ? void 0 : getVideoDuration(data.duration);
                return {
                    ack: "OK"
                };
            default:
                return {
                    ack: "ERROR"
                };
        }
    };
    var getStoryContent = function() {
        var InnerContent = story.content;
        var config = {
            width: width,
            height: height,
            loader: loader,
            header: header,
            storyStyles: storyStyles
        };
        return /*#__PURE__*/ _jsx(InnerContent, {
            action: action,
            isPaused: playState,
            story: story,
            config: config,
            messageHandler: rendererMessageHandler
        });
    };
    return /*#__PURE__*/ _jsx(StoryStyled, {
        className: "story",
        style: _object_spread_props(_object_spread({}, storyInnerContainerStyles), {
            width: width,
            height: height
        }),
        children: getStoryContent()
    });
};
export default Story;
